<div class="d-flex">
  <div class="px-0"
    [ngClass]="(location === 'front-facing') ? 'col-4' :
      ((location === 'add-association') ? 'col-12' : 'col-auto')">
    <span class="search-icon position-absolute">
      <em class="material-icons-outlined font-4x mt-1" aria-hidden="true">search</em>
    </span>
    <label for="searchTaxonomies" id="searchTaxonomiesLabel" class="sr-only">Search</label>
    <input
      type="search"
      [attr.readonly]="intializeCondition ? 'readonly' : null"
      placeholder="Search"
      class="form-control search-inputfield"
      [(ngModel)]="searchText" id="searchTaxonomies"
      (keyup.enter)="emitSearchText(false)"
      (keyup)="checkSearchText()"
      autocomplete="off">
    <button
      *ngIf="searchText?.length !== 0"
      type="button" id="clearsearchBtn"
      class="btn-clear cursor-pointer position-absolute search-clear border-0"
      aria-label="Clear search"
      (click)="cancelSearch()">&times;</button>
  </div>

  <div *ngIf="showFilter" class="col-auto px-2" (clickOutside)="onClickOutside()">
    <div class="dropdown d-flex align-items-center">
      <div>
      <button
        [attr.disabled]="intializeCondition || !filterListObj ? 'true' : null" type="button"
        id="dropdownFilterButton"
        class="btn btn-icon btn-common d-flex align-items-center"
        [attr.aria-label]="'Add filters'"
        [attr.aria-haspopup]="!openPanel"
        [attr.aria-expanded]="openPanel"
        (click)="toggleFilterPanel()"
        [ngClass]="{'filters_active':filterObj.length}"
        [clickOutsideEnabled]="false">
        <em class="material-icons-outlined button-icon font-4x" aria-hidden="true">tune</em>
        <span class="ml-2" *ngIf="filterObj.length">
          {{filterObj.length + (filterObj.length > 1 ? ' filters' : ' filter')}} applied
        </span>
      </button>
    </div>
      <div>
        <button
          type="btn"
          class="btn btn-clear text-underline ml-1"
          id="resetSearchFilterBtn"
          [disabled]="!isSearchApplied"
          (click)="resetSearchFilter()">Reset</button>
      </div>
      <span *ngIf="intializeCondition" role="alert"> Initializing data for search
        <img
          src="../../../align/assets/images/initializeLoader.gif"
          class="img-fluid" alt="preloader">
        </span>
      <div class="dropdown-menu dropdown-menu--filter p-3"
        *ngIf="filterListObj"
        aria-labelledby="dropdownFilterButton"
        [ngClass]="{'show': openPanel}">

        <ng-container *ngFor="let key of Object.keys(filterListObj)">
          <app-multi-select-dropdown
            class="d-flex w-100 mb-3"
            #filterCriteria
            [label]="filterListObj[key][0]['display_name']"
            [viewLocation]="'tree-search'"
            [data]="filterListObj[key]"
            id="{{'-multiselect-'+key}}"
            [dropdownSettings]="dropdownSettings"
            [isTreeSearch]="true"
            (SelectEvent)="getSelectedFilters($event)">
          </app-multi-select-dropdown>
        </ng-container>

        <div class="col-12 d-flex p-0 justify-content-end mt-3">
          <button
            type="button"
            class="btn-clear border-0 mr-2 text-underline"
            id="resetFilterBtn"
            [disabled]="!filterObj.length"
            (click)="clearFilter()">Reset</button>

          <button
            type="button"
            class="btn btn-primary"
            id="applyFilterBtn"
            [disabled]="disableFilter"
            (click)="applyFilter()">Filter</button>
        </div>
      </div>
    </div>
  </div>
</div>
